<template>
	<div class="recievers-groups">
		<div class="recievers-groups__control-buttons mb-4">
            <div class="title-block__title">Группы получателей</div>
			<a class="title-block__btn btn-add btn-primary btn" :href="route_group_create">Добавить группу</a>
		</div>

		<div class="recievers-groups__recievers mb-4">
			<div class="filter-table__input-wrap search-control">
				<input type="text"
                       @keyup.delete="onDeleteSearch()"
                       @keyup.enter="onSearch()"
                       v-model="search"
                       class="search-control__input form-control"
                       placeholder="Поиск"
                >
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>
		</div>

		<table class="table align-middle w-auto" style="min-width: 400px;">
			<thead>
				<tr>
					<th scope="col" v-for="elem in thead">
						<div v-if="elem == 'Действия'" class="th-inner sortable asc actions-row-label">
							{{ elem }}
						</div>
						<div v-else class="th-inner sortable asc">
							{{ elem }}
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
					<td>{{ row.tbody.name }}</td>
                    <td>{{ row.tbody.emails_count }}</td>
					<td>
						<div class="d-flex">
							<a :href="route_group_edit + row.id" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></a>
							<button @click="deleteGroup(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>

import Receivers from '../../../../models/Mailings/Receivers';
import PaginationElement from '../../../../elements/PaginationElement.vue';

export default {
	name: 'RecieversGroupComponent',
    components: { PaginationElement },
    props: {
        route_list: String,
        route_delete: String,
        route_group_edit: String,
        route_group_create: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
	data: function () {
		return {
            group: new Receivers({
                route_list: this.route_list,
                route_delete: this.route_delete,
                route_update: this.route_group_edit
            }),
			thead: [
                'Название группы',
                'Количество получателей',
                'Действия'
            ],
            tbody: [],
            count: 1,
            limit: 30,
            page: 1,
            search: ''
		};
    },
    methods: {
        loadTable: async function () {
            let response = await this.group.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
        },
        deleteGroup: function (group_id) {
            let conf = confirm('Вы уверены что хотите удалить группу?');
            if(!conf) {
                return;
            }
            if (conf) {
                this.group.delete(group_id).then(this.loadTable);
            }
        },
        onSearch: async function() {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() == '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
    },
    mounted() {
        this.loadTable();
    }
}

</script>

<style scoped lang="scss">
.recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 24px;
    }
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.actions-row-label {
    text-align: center;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.selected-reciever {
    height: 36px;
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}
</style>
